import { useOrganizationInvitesList } from 'modules/Organizations/hooks';
import { useEffect } from 'react';
import { addNotification, removeNotification } from 'components/Navbar/components/Notifications/notificationStore';
import { makeUserFullName } from 'utils/users';
import cogoToast from 'components/ToastMessage/ToastMessage';
import { useAcceptOrgInvitation, useDeclineOrgInvitation } from '../JoinOrganization/hooks';

export const useOrgInvitationNotification = () => {
  const { orgInvitesList, refetch } = useOrganizationInvitesList();
  // Hooks for handling organization invitation actions
  const acceptOrgInvitation = useAcceptOrgInvitation();
  const declineOrgInvitation = useDeclineOrgInvitation();

  useEffect(() => {
    orgInvitesList?.forEach((orgInvitation) => {
      const notificationId = addNotification({
        id: `org_invite_${orgInvitation.id}`,
        title: orgInvitation.organization.name,
        header: `You have been invited to join ${orgInvitation.organization.name} organization`,
        body: `${makeUserFullName(orgInvitation.inviter as CF.API.Users.User)} has invited you to join as a ${orgInvitation.role.name}`,
        createdDate: orgInvitation.created_at,
        hideIcon: false,
        className: '',
        isLoading: false,
        acceptBtn: {
          text: 'Accept',
          onClick: () => {
            acceptOrgInvitation.mutate(orgInvitation, {
              onSuccess: () => {
                removeNotification(notificationId);
                refetch();
                cogoToast.success(`You have accepted the organization ${orgInvitation.organization.name} invitation.`);
              },
              onError: () => {
                cogoToast.error('Failed to accept the invitation. Please try again.');
              },
            });
          },
          disabled: false,
        },
        declineBtn: {
          text: 'Decline',
          onClick: () => {
            declineOrgInvitation.mutate(orgInvitation, {
              onSuccess: () => {
                removeNotification(notificationId);
                refetch();
                cogoToast.success(`You have declined the organization ${orgInvitation.organization.name} invitation.`);
              },
              onError: () => {
                cogoToast.error('Failed to decline the invitation. Please try again.');
              },
            });
          },
          disabled: false,
        },
      });
    });
  }, [orgInvitesList, acceptOrgInvitation, declineOrgInvitation, refetch]);
};
